import { render } from 'preact';
import App from './App';
import './styles/global.css';

render(<App />, document.getElementById('app'));
